// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2vvqC","title":"FrontImage_title__30lr-"};